export default function Descriptions() {
  return {
    lineHeight: 1
  }
}
